/**
 * Created by calhosh on 9/6/2024
 */

import React, {useState, useCallback, useRef} from 'react';
import {AGGridEnterprise} from '@ey/canvascoreservices';
import styled from 'styled-components';

export default function AgGridWrapper(props) {
	const {onReady, containerClassName} = props;

	const innerRef = useRef(null);

	const [customStyle, setCustomStyle] = useState({display: 'none'});

	const handleOnGridReady = useCallback((params) => {
		onReady && onReady(params);
		innerRef.current = params.api;
		const grids = document.querySelectorAll(`section.AGGridWrapperSection`);
		if (grids && grids.length > 0) {
			grids.forEach((grid) => {
				const agBodyViewport = grid.querySelector('.ag-body-viewport');
				const agFullWidthRow = grid.querySelector('.ag-full-width-row');
				if (agBodyViewport) {
					agBodyViewport.classList.add('customScrollbar');
				}
				if (agFullWidthRow) {
					agFullWidthRow ?? agFullWidthRow.classList.add('customScrollbar');
				}
			});

			resizeGrid(params);

			window.addEventListener('resize', function() {
				resizeGrid(params);
			});
		}
	}, []);

	const resizeGrid = (params) => {
		params.api.sizeColumnsToFit();

		//When columns resize to fit, we remove the display none to avoid showing the grid column shifting.
		setCustomStyle({});
	};

	return (
		<StyledAGGridEnterprise className={`StyledAGGridEnterprise ${containerClassName}`} style={customStyle}>
			<AGGridEnterprise {...props} onGridReady={handleOnGridReady} />
		</StyledAGGridEnterprise>
	);
}

const StyledAGGridEnterprise = styled.section`
	height: 100%;
	.ag-cell {
		// padding-right: 0 !important;
		.ag-cell-wrapper {
			width: 100%;
			align-items: center;
			.ag-icon {
				height: var(--px-24);
			}
			.ag-group-value {
				width: 100%;
			}
			.ag-cell-value {
				width: 100%;
			}
		}
	}
	.ag-body {
		min-height: var(--px-40);
	}
`;
